module.exports = __webpack_public_path__ + "static/media/the-aa-logo.4c3279cc.svg";